export default __webpack_public_path__ + "static/media/line4_1.5d2f724b.svg";